import React, { useEffect } from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { ExhibitionContainer, PageTitle } from '../styles/exhibitionStyles';

const CVText = styled.p`
  font-size: 14px;
  line-height: 1.6;
  margin-bottom: 10px;
`;

const CVSection = styled.div`
  margin-bottom: 30px;
`;

const CVTitle = styled.h3`
  font-size: 14px;
  font-weight: 700;
  margin-bottom: 10px;
  margin-top: 20px;
`;

const InterviewLink = styled(Link)`
  color: black;
  text-decoration: underline;
  font-size: 14px;
  line-height: 1.6;
  margin-bottom: 10px;
  display: block;

  &:hover {
    text-decoration: underline;
  }
`;

const ExternalLink = styled.a`
  color: black;
  text-decoration: underline;
  font-size: 14px;
  line-height: 1.6;
  margin-bottom: 10px;
  display: block;

  &:hover {
    text-decoration: underline;
  }
`;

export default function CV() {
  useEffect(() => {
    document.title = "CV - SLEEPR";
  }, []);

  return (
    <ExhibitionContainer>
      <PageTitle>CV</PageTitle>

      <CVTitle>SLEEPR</CVTitle>
      <CVText>Born in 1988, Australia</CVText>

      <CVSection>
        <CVTitle>Education</CVTitle>
        <CVText>2008 Bachelor of Arts, QUT, AU</CVText>
        <CVText>2011 Masters of Arts, QUT, AU</CVText>
        <CVText>2013 Doctor of Philosophy, IHBI, AU (Incomplete)</CVText>
      </CVSection>

      <CVSection>
        <CVTitle>Solo Exhibitions</CVTitle>
        <CVText>2025 "Dream Machines", Metro Arts, QLD, AU</CVText>
        <CVText>2024 "Secrets", Scene, Soho, London</CVText>
      </CVSection>

      <CVSection>
        <CVTitle>Group Exhibitions</CVTitle>
        <CVText>2025 "New Visions: Mind Art", Institute of Contemporary Visionary Art, AU</CVText>
        <CVText>2024 "Meditations On Chicago: (a 'new) digital dawn", Chicago, US</CVText>
        <CVText>2024 "Prima Vere", NY</CVText>
        <CVText>2023 "Contemporary Discoveries: Down The Rabbit Hole", Sotheby's, Hong Kong</CVText>
        <CVText>2023 "ExchangeArt: Art Futures", Miami Beach, US</CVText>
        <CVText>2023 "Hacker House", Melbourne, AU</CVText>
        <CVText>2022 "Space World", US</CVText>
        <CVText>2022 "Hacker House", Barcelona, Spain</CVText>
        <CVText>2006 "The Bleeding Edge", Jugglers Art Space, QLD, AU</CVText>
        <CVText>2005 "Underground Arts: A showcase of emerging artists", Channon Gallery, AU</CVText>
      </CVSection>

      <CVSection>
        <CVTitle>Artist Residency</CVTitle>
        <CVText>2024 "Hidden Worlds" Art Basel Miami</CVText>
      </CVSection>

      <CVSection>
        <CVTitle>Auction House Sales</CVTitle>
        <CVText>2023 "Contemporary Discoveries: Down The Rabbit Hole", Sotheby's, Hong Kong</CVText>
      </CVSection>

      <CVSection>
        <CVTitle>Articles, Exhibition Catalogues and General Publications</CVTitle>

        <InterviewLink to="/articles/the-boy-and-the-plant"><CVText>2024 Article, "The Boy And The Plant", Lauren McMahon, Australia</CVText></InterviewLink>
        <ExternalLink href="/files/sleepr-secrets-catalogue-full.pdf" target="_blank" rel="noopener noreferrer"><CVText>2024 Article, "Secrets: Catalogue", Scene, Soho, London</CVText></ExternalLink>
        <InterviewLink to="/articles/the-secret-world-of-sleepr"><CVText>2024 Article, "The Secret World Of Sleepr", Naomi Bu, London</CVText></InterviewLink>
        <InterviewLink to="/articles/sleeprs-secret-ontological-quest"><CVText>2024 Article, "Sleepr's Secret Ontological Quest", Elizabeth Forrest, USA</CVText></InterviewLink>
        <CVText>2024 Article, "Collect Art: Autumn", Collector, USA</CVText>
        <CVText>2024 Article, "101 Contemporary Artists, and more..", Art Collector, USA</CVText>
        <ExternalLink href="https://visualartjournal.com/2024/09/09/sleepr/" target="_blank" rel="noopener noreferrer"><CVText>2024 "Interview with Sleepr", Visual Art Journal #8, Germany</CVText></ExternalLink>
        <InterviewLink to="/interviews/fabuk-magazine-the-secrets-show"><CVText>2024 "Interview with the artist Sleepr of Secrets Exhibition", FabUK Magazine, London</CVText></InterviewLink>
        <InterviewLink to="/articles/portals-accessing-and-storing-information-in-quantum-folders"><CVText>2021 Article,"Portals: Accessing and storing information in quantum folders", Sleepr, Australia</CVText></InterviewLink>
      </CVSection>

      <CVSection>
        <CVTitle>Interviews</CVTitle>
        <InterviewLink to="/interviews/one-artist-one-artwork-interview">2024 One Artist One Artwork Interview, London</InterviewLink>
        <InterviewLink to="/interviews/goku-and-sleepr-interview">2024 Goku and Sleepr Interview, New York</InterviewLink>
        <InterviewLink to="/interviews/dan-and-sleepr-interview">2024 Dan and Sleepr Interview, London</InterviewLink>
        <InterviewLink to="/interviews/fabuk-magazine-the-secrets-show">2024 FabUK Magazine and Sleepr Interview, London</InterviewLink>
        <InterviewLink to="/interviews/behind-the-art-interview-and-profile">2024 Exchange Art and Sleepr Interview, Miami</InterviewLink>
        <InterviewLink to="/interviews/odk-and-sleepr-interview">2023 ODK and Sleepr Interview, Los Angeles</InterviewLink>
        <InterviewLink to="/interviews/sol-city-and-sleepr-interview">2023 Sol City and Sleepr Interview, Brazil</InterviewLink>
        <InterviewLink to="/interviews/pedro-and-sleepr-interview">2023 Pedro and Sleepr Interview, Brazil</InterviewLink>
        <InterviewLink to="/interviews/boogle-and-sleepr-interview">2022 Boogle and Sleepr Interview, Portugal</InterviewLink>
        <InterviewLink to="/interviews/pengu-and-sleepr-interview">2022 Pengu and Sleepr Interview, Minnesota</InterviewLink>
        <InterviewLink to="/interviews/shake-and-sleepr-interview">2022 Shake and Sleepr Interview, Los Angeles</InterviewLink>
      </CVSection>
    </ExhibitionContainer>
  );
}
